import { CommonModule } from '@angular/common';
import {
Component,
EventEmitter,
HostBinding,
Input,
OnChanges,
Output
} from '@angular/core';
import { Router,RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconComponent } from 'angular-tabler-icons';
import { NavService } from '../../../../../../../../shared/src/lib/services/nav.service';
import { MaterialModule } from '../../../../../material.module';
import { NavItem } from './nav-item';

@Component({
    selector: 'app-nav-item',
    imports: [TranslateModule, TablerIconComponent, MaterialModule, CommonModule, RouterModule],
    templateUrl: './nav-item.component.html',
    styles: [`
      .indicator-icon {
        transition: transform 225ms cubic-bezier(0.4, 0, 0.2, 1);
        display: inline-block;
        &.expanded {
          transform: rotate(180deg);
        }
      }
    `]
})
export class AppNavItemComponent implements OnChanges {
  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  expanded: any = false;
  disabled: any = false;
  twoLines: any = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem | any;
  @Input() depth: any;

  constructor(
    public navService: NavService,
    public router: Router,
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnChanges() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
        // console.log(`Checking '/${this.item.route}' against '${url}'`);
        this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
        //console.log(`${this.item.route} is expanded: ${this.expanded}`);
      }
    });
  }

  onItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      this.router.navigate([item.route]);
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
    //scroll
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    if (!this.expanded) {
      if (window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }

  onSubItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (this.expanded && window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }

}
